import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dialog } from "primereact/dialog";
import { useLoader } from "../../hooks/LoaderContext";
import "./index.css";

const Loader = () => {
  const { isLoaderEnabled = false } = useLoader();

  if (!isLoaderEnabled)  return null;
  return (
    <Dialog
      visible={isLoaderEnabled}
      content={<ProgressSpinner style={{ width: 50, height: 50 }} />}
      style={{ background: "none", boxShadow: "none", overflow: "hidden" }}
    />
  );
};

export default Loader;